import { EntityTable } from 'Dexie';
import { z } from 'zod';

export const PublicationFileTableSchema = z.object({
  id: z.number().optional(),
  file: z.string(),
  extension: z.string(),
  name: z.string(),
  path: z.string(),
  documentId: z.number(),
  datePublication: z.string(),
})

export type PublicationFileTable = z.infer<typeof PublicationFileTableSchema>;
export type DexiePublicationFilesTable = EntityTable<PublicationFileTable, 'id'>;
export const PublicationFileTableColumn = '++id, file, extension, name, path, documentId, datePublication';
